import styled from "styled-components";

export const CopyrightWrapper = styled.div`
  // display: none;

  p {
    color: grey;
    font-size: 11px;
    margin-bottom: 0;
    position: absolute;
    left: 35px;
    bottom: 35px;

    &.large-font {
      font-size: 13px;
    }
  }

  img {
    width: 120px;
    position: absolute;
    right: 35px;
    bottom: 35px;

    @media print {
      right: 48px;
    }

    &.small {
      width: 90px;
    }
  }

  @media print {
    display: block;
  }
`;



// WEBPACK FOOTER //
// ./src/components/SRHCopyright/style.js